export const getActualColor = (actual: number, budget: number) => {
  if (actual > budget) {
    return 'text-green-600';
  } else if (actual >= budget * 0.95) {
    return 'text-yellow-600';
  } else {
    return 'text-red-600';
  }
};

export const getBillableRateColor = (billableRateSoFar: number, budgetBillableRate: number) => {
  const billableRatePercent = billableRateSoFar * 100;
  if (billableRatePercent >= budgetBillableRate) {
    return 'text-green-600';
  } else if (billableRatePercent >= budgetBillableRate * 0.95) {
    return 'text-yellow-600';
  }
  return 'text-red-600';
};

export const getUpcomingWeekColor = (weekValue: number, budgetBillableRate: number) => {
  if (weekValue > budgetBillableRate) {
    return 'text-green-600';
  } else if (weekValue >= budgetBillableRate * 0.95) {
    return 'text-yellow-600';
  } else {
    return 'text-red-600';
  }
};

export const formatSignedHours = (value: number) => {
  const rounded = Math.round(value || 0);
  return rounded >= 0 ? `+${rounded}` : `${rounded}`;
};

export const getLoggedHoursDiffClasses = (diff: number, budgetHoursAOY: number) => {
  if (!budgetHoursAOY || budgetHoursAOY <= 0) {
    return 'text-gray-500';
  }

  if (diff < -0.1 * budgetHoursAOY) {
    return 'text-red-600 bg-red-50/50';
  }

  if (diff < 0) {
    return 'text-yellow-600 bg-yellow-50/50';
  }

  return 'text-green-600 bg-green-50/50';
};

export const getBudgetVsActualColor = (budget: number, actual: number) => {
  if (budget === 0) return '';
  const ratio = actual / budget;
  if (ratio > 1) {
    return 'bg-green-50/50';
  } else if (ratio >= 0.95) {
    return 'bg-yellow-50/50';
  } else {
    return 'bg-red-50/50';
  }
};

export const getBudgetVsActualColorBold = (budget: number, actual: number) => {
  if (budget === 0) return '';
  const ratio = actual / budget;
  if (ratio > 1) {
    return 'bg-green-100/50';
  } else if (ratio >= 0.95) {
    return 'bg-yellow-100/50';
  } else {
    return 'bg-red-100/50';
  }
};
